module.exports = __webpack_public_path__ + "img/progress_right.35ff724c.svg";